import React from "react";
import { PageSkeleton } from "./Skeleton";
import "../assets/css/loader.css";

/**
 * Page loading state — renders a skeleton of the page instead of a spinner.
 *
 * Keeps the original <Loader isLoading /> API so every existing call site works
 * unchanged. `isLoading` now defaults to true so a bare <Loader /> renders too
 * (it previously rendered nothing, leaving some pages blank while loading).
 *
 * variant: "table" (default) | "dashboard" | "cards" | "chart" | "profile"
 * inline:  render in normal flow (inside a card/section) instead of as a
 *          full-page overlay.
 */
const Loader = ({
  isLoading = true,
  variant = "table",
  rows = 8,
  cols = 6,
  inline = false,
  height,
}) => {
  if (!isLoading) return null;

  const skeleton = <PageSkeleton variant={variant} rows={rows} cols={cols} />;

  if (inline) {
    return (
      <div className="sk-inline" style={height ? { minHeight: height } : undefined}>
        {skeleton}
      </div>
    );
  }

  return <div className="container-loader">{skeleton}</div>;
};

export default Loader;
